window.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    const mm = gsap.matchMedia();
    const tl = gsap.timeline({ repeat: -1 });
  
    mm.add("(max-width: 767px)", () => {
      tl.to(".outer_ring", {
        duration: 1,
        width: "150vw",
        padding: "75vw 0",
        opacity: 0,
        repeatDelay: 1,
      });
      tl.to(
        ".inner_ring",
        {
          duration: 2,
          width: "150vw",
          padding: "75vw 0",
          opacity: 0,
        },
        "<"
      );
    });
  
    mm.add("(min-width: 768px)", () => {
      tl.to(".outer_ring", {
        duration: 3,
        width: "150vw",
        padding: "75vw 0",
        opacity: 0,
        repeatDelay: 1,
      });
      tl.to(
        ".inner_ring",
        {
          duration: 4,
          width: "150vw",
          padding: "75vw 0",
          opacity: 0,
        },
        "<"
      );
    });
    tl.addLabel("end");
    window.addEventListener("scroll", () => {
      if (window.scrollY === 0) {
        tl.restart();
        tl.repeat(-1);
      } else {
        if (tl.vars?.repeat === -1) {
          tl.tweenTo("end").repeat(0);
        }
      }
    });
  },500)
});
